// Direct local requests need the Cognito context normally supplied by API Gateway.
export function getLocalCoreServicesHeaders (api) {
  if (process.env.NODE_ENV !== 'development' || api?.name !== 'CoreServicesAPI') return {};
  if (!api.endpoint || !['localhost', '127.0.0.1', '[::1]'].includes(new URL(api.endpoint).hostname)) return {};

  return {
    'x-caller-id': 'local:CognitoIdentityCredentials',
    'x-iam-user': 'local:CognitoIdentityCredentials',
    'x-cognito-type': 'authenticated',
    'x-cognito-id': 'id'
  };
}
